import { render } from "./DeleteComp.vue?vue&type=template&id=43419b74"
import script from "./DeleteComp.vue?vue&type=script&lang=js"
export * from "./DeleteComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__